import { render } from "./TextBoxMultiple.vue?vue&type=template&id=dbc15c7c"
import script from "./TextBoxMultiple.vue?vue&type=script&lang=js"
export * from "./TextBoxMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TextBoxMultiple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dbc15c7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dbc15c7c', __exports__)) {
    api.reload('dbc15c7c', __exports__)
  }
  
  module.hot.accept("./TextBoxMultiple.vue?vue&type=template&id=dbc15c7c", () => {
    api.rerender('dbc15c7c', render)
  })

}


export default __exports__